const ContactPhonePrefix = '+1';

export const numberFormat = (
  num,
  country = 'en-US',
  params = { maximumFractionDigits: 2 }
) => {
  if (typeof num !== 'string' && typeof num !== 'number') return;

  if (typeof num === 'string' && /^[0-9,.\s]+$/.test(num)) {
    return num;
  }

  const formattedToNumber = Number(num);

  if (Number.isNaN(formattedToNumber)) {
    return '';
  }

  return formattedToNumber.toLocaleString(country, params);
};

export const unformatNumber = (num) => {
  if (!num || typeof num !== 'string' && typeof num !== 'number') return null;
  if (typeof num === 'number') return num;
  
  const cleaned = num.toString().replace(/,/g, '');
  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? null : parsed;
};

export const unformatPrice = (price) => {
  if (!price || typeof price !== 'string' && typeof price !== 'number') return null;
  if (typeof price === 'number') return Math.abs(price);
  
  // Remove currency symbols, parentheses, commas, and spaces
  // Handle various currency symbols like $, €, £, ¥, etc.
  let cleaned = price.toString()
    .replace(/[$€£¥₹₽¢₩₪₦₨₱₡₵₴₸₺₼₾₿]/g, '') // Common currency symbols
    .replace(/[(),\s]/g, '') // Remove parentheses, commas, spaces
    .replace(/[-+]/g, ''); // Remove negative/positive signs to get absolute value
  
  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? null : parsed;
};

export const numberWithCommas = (number = 0) => {
  if (number === null || number === undefined) {
    return '0';
  }
  return isNaN(number)
    ? '0'
    : number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const convertKmToMiles = (km = 0) => {
  return Math.round(Number(km) / 1.609);
};

/**
 * Phone number formatter extracted from legacy code.
 *
 * @param {string} value - Non-formatted phone number
 * @returns {string} Formatted phone number
 */
export const formatPhone = (value) => {
  if (value === undefined) {
    return undefined;
  }
  
  if (!value) {
    return '';
  }

  // it removes all non-digit characters
  let digits =  value.replace(/\D/g, '');
  digits = digits.slice(-10); // Ensure we only take the last 10 digits

  const str = digits.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

  return !str[2]
    ? str[1]
    : `(${str[1]}) ${str[2]}${str[3] ? `-${str[3]}` : ''}`;
};

export const normalizePhone = (phone = '') => {
  return phone ? `${ContactPhonePrefix}${phone}` : '';
};

export const phoneValidation = (phone = '') => {
  return cleanPhone(phone)?.toString()?.length === 10 && phone;
};

export const cleanPhone = (phone = '') => {
  return phone.trim().replace(/[^\d]/g, '');
};

export const percentageCalculator = (amount = 0, percentage = 100) =>
  Math.round(amount * (percentage / 100));

const NumberRegex = /^\d+$/;

export const checkNumberString = (str) => NumberRegex.test(str);

export const formatWithCommas = (value) => {
  // If already formatted (contains commas), add extra commas
  return value.replace(/,/g, ',,').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
